var map = {
	"./logo-OST2-m.png": 511,
	"./logo-OST2.png": 512,
	"./logo-Sync2-Cloud-m.png": 513,
	"./logo-Sync2-Cloud.png": 514,
	"./logo-duplicate-killer-m.png": 515,
	"./logo-duplicate-killer.png": 516,
	"./logo-ostpstviewer-m.png": 517,
	"./logo-ostpstviewer.png": 518,
	"./logo-outlook-duplicate-remover-m.png": 519,
	"./logo-outlook-duplicate-remover.png": 520,
	"./logo_SPB.png": 521,
	"./undefined.png": 522
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 510;